<mat-form-field class="search-field">
  <mat-icon class="search-icon" matPrefix>search</mat-icon>
  <input #seachField matInput (keyup)="applyFilter($event.target['value'])" placeholder="Navn eller sted"
    [(ngModel)]="value" (click)="seachField.select()">
  <mat-icon *ngIf="value" matSuffix (click)="value=''; applyFilter('')" class="clear">close</mat-icon>
</mat-form-field>


<div class="alarm-list" *ngIf="isSupport && isMobile === false" [class.collapsed]="!alarmListOpen">
  <mat-icon class="alarm-toggle" (click)="toggleAlarmList()">{{ alarmListOpen ? 'expand_less' : 'expand_more'
    }}</mat-icon>
  <div *ngIf="alarmListOpen">
    <div class="alarm-summary">
      <strong style="color: #ff9800;">Warnings:</strong> <span style="color: #ff9800;">{{ warningCount }}</span>
      &nbsp;|&nbsp;
      <strong style="color: #f44336;">Faults:</strong> <span style="color: #f44336;">{{ faultCount }}</span>
    </div>
    <div *ngFor="let alarm of alarmsSorted" [ngClass]="alarm.type" style="margin-bottom: 0px;">

      <div class="alarm-message-row" style="display: flex; flex-direction: column; align-items: flex-start; width: 100%;"  [class]="{blinking: alarm.blinking}">
        <div style="display: flex; align-items: center; margin-bottom: 2px;">
          <mat-icon *ngIf="alarm.type === 'warning'" style="color: #ff9800; margin-right: 4px;">warning</mat-icon>
          <mat-icon *ngIf="alarm.type === 'fault'" style="color: #f44336; margin-right: 4px;">error</mat-icon>

          <a *ngIf="alarm.systemNumber" class="alarm-system-link" (click)="goToServicePopupForSystem(alarm.systemId)" [matTooltip]="alarm.tooltip">
            <b>{{ alarm.alarmTitle }}</b>
          </a>
          <span *ngIf="!alarm.systemNumber" [matTooltip]="alarm.tooltip">
            <b>{{ alarm.alarmTitle }}</b>
          </span>
        </div>
        <span style="display: block; width: 100%;">{{ alarm.message }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!alarmListOpen" class="alarm-summary">
    <strong style="color: #ff9800;">Warnings:</strong> <span style="color: #ff9800;">{{ warningCount }}</span>
    &nbsp;|&nbsp;
    <strong style="color: #f44336;">Faults:</strong> <span style="color: #f44336;">{{ faultCount }}</span>
  </div>
</div>

<ng-container *ngIf="true; else onlyForCuboid">
  <mat-tab-group (selectedIndexChange)="tabChanged($event)" [selectedIndex]="tabIndex" class="tab-group"
    mat-align-tabs="start" backgroundColor="theme" class="navbar1" animationDuration="0ms">

    <mat-tab label="Sites">
      <app-card-view-layout (onAdd)="onAddSite()" [showAdd]="auth.isSuperAdmin(user)" [data]="filterdSites$"
        [actionButtons]="actionButtons" (onDelete)="onDeleteSite($event)" (onUpdate)="onUpdateSite($event)"
        [showListSelect]="true" [showEdit]="true">
      </app-card-view-layout>
    </mat-tab>

    <mat-tab label="Systems (beta)">
      <app-card-view-layout [data]="filterdSystems$" [showListSelect]="true" [showEdit]="false" [showAdd]="false" [showDelete]="false"
        [actionButtons]="actionButtonsSystems" [useSystems]="true" [sort]="false"></app-card-view-layout>
    </mat-tab>


  </mat-tab-group>
</ng-container>

<ng-template #onlyForCuboid>
  <app-card-view-layout [data]="filterdSystems$" [showListSelect]="true" [showEdit]="false" [showDelete]="false"
    [actionButtons]="actionButtonsSystems" [useSystems]="true"></app-card-view-layout>
</ng-template>